(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post-cinematic"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript.closest('article.cin-article') || document.querySelector('article.cin-article');
    if (!section) return;

    const tocList = section.querySelector('[data-toc] .cin-toc__list');
    const body = section.querySelector('[data-article-body]');

    // Tabellen in een scroll-wrapper zetten (nette weergave + mobiel scrollen)
    if (body) {
      body.querySelectorAll(':scope > table').forEach(function (tbl) {
        if (tbl.parentElement && tbl.parentElement.classList.contains('cin-table-scroll')) return;
        const wrap = document.createElement('div');
        wrap.className = 'cin-table-scroll';
        tbl.parentNode.insertBefore(wrap, tbl);
        wrap.appendChild(tbl);
      });
    }

    if (!tocList || !body) return;

    const headings = body.querySelectorAll(':scope > h2[id], :scope > h2:not([id])');
    if (!headings.length) {
      const toc = section.querySelector('[data-toc]');
      if (toc) toc.style.display = 'none';
      return;
    }

    const items = [];
    headings.forEach((h, i) => {
      if (!h.id) {
        const slug = (h.textContent || '').toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-') || ('h-' + i);
        h.id = slug;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.dataset.target = h.id;
      a.innerHTML = '<span class="cin-toc__num">0' + (i + 1) + '</span><span class="cin-toc__label-text">' + h.textContent + '</span>';
      li.appendChild(a);
      tocList.appendChild(li);
      items.push({ id: h.id, link: a, el: h });
    });

    if (items.length === 0) return;

    items[0].link.classList.add('is-active');

    const setActive = (id) => {
      items.forEach(it => it.link.classList.toggle('is-active', it.id === id));
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        let active = items[0].id;
        for (const it of items) {
          if (it.el.getBoundingClientRect().top < 200) active = it.id;
        }
        setActive(active);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-cinematic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('article.cin-page').forEach(function (section) {
      var body = section.querySelector('[data-page-body]');
      if (!body) return;

      // Tabellen in een scroll-wrapper zetten
      body.querySelectorAll(':scope > table').forEach(function (tbl) {
        if (tbl.parentElement && tbl.parentElement.classList.contains('cin-table-scroll')) return;
        var wrap = document.createElement('div');
        wrap.className = 'cin-table-scroll';
        tbl.parentNode.insertBefore(wrap, tbl);
        wrap.appendChild(tbl);
      });

      var tocList = section.querySelector('[data-toc] .cin-toc__list');
      if (!tocList) return;

      var headings = body.querySelectorAll(':scope > h2');
      if (!headings.length) {
        var toc = section.querySelector('[data-toc]');
        if (toc) toc.style.display = 'none';
        return;
      }

      var items = [];
      headings.forEach(function (h, i) {
        if (!h.id) {
          h.id = (h.textContent || '').toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-') || ('h-' + i);
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.innerHTML = '<span class="cin-toc__num">0' + (i + 1) + '</span><span class="cin-toc__label-text"></span>';
        a.querySelector('.cin-toc__label-text').textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
        items.push({ id: h.id, link: a, el: h });
      });

      items[0].link.classList.add('is-active');

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var active = items[0].id;
          items.forEach(function (it) {
            if (it.el.getBoundingClientRect().top < 200) active = it.id;
          });
          items.forEach(function (it) {
            it.link.classList.toggle('is-active', it.id === active);
          });
          ticking = false;
        });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
